export default __webpack_public_path__ + "static/media/d-comment.67cb3f3c.svg";